<template>
  <div class="panel-group last-panel">
    <div class="panel">
      <div class="col-md-12" v-if="type === 1">
        <hr />
        <p>Parabéns pela qualificação da sua Franquia na PTC 2025!</p>
        <p>
          Na próxima página você deverá preencher TODOS os campos com as
          informações necessárias para seguir com a sua inscrição e de seus
          acompanhantes (qualificados e extras), se houver.
        </p>
        <p>
          <b>Para este preenchimento será necessário ter em mãos o passaporte e
            visto americano válidos (a data de validade do passaporte deverá ser
            superior a data de retorno dos Estados Unidos).</b>
          Caso ainda não possua essas documentações, por favor, selecione a
          opção “não possuo” e envie as informações até o dia 31 de março para 
          <a href="ptcpiic.brasil@prudential.com ">ptcpiic.brasil@prudential.com</a>
        </p>
        <p>
          No caso de dúvidas recomendamos a leitura do manual do site de
          inscrição e dos comunicados enviados pela Franqueadora.<br /><br />
          Contato com a Origami: PREFERENCIALMENTE VIA WHATSAPP, com a Central
          de Atendimento exclusiva da PTC no número: (21) 98819-0007. Horário de atendimento: segunda a sexta de 9h às
          18h
        </p>
        <p>Pronto(a)? Então, vamos lá!</p>
        <button @click="$emit('nextButton')">Próximo</button>
      </div>
      <div class="col-md-12" v-if="type === 2">
        <hr />
        <div class="col-lg-12">
          <div class="checkbox" style="margin: 15px">
            <input type="checkbox" id="confirmInfo1" v-model="confirmInfo1" />
            <label for="confirmInfo1">
              Autorizo a coleta, manipulação e compartilhamento, pela Prudential
              do Brasil, Origami Eventos e M&W Turismo, das informações
              solicitadas nesse formulário para fim de inscrição na PTC 2025.
            </label>
            <input type="checkbox" id="confirmInfo2" v-model="confirmInfo2" />
            <label for="confirmInfo2">
              Declaro que as informações preenchidas nesse formulário são
              verdadeiras e passíveis de comprovação no caso de solicitação pela
              Franqueadora.
            </label>
            <input type="checkbox" id="confirmInfo3" v-model="confirmInfo3" />
            <label for="confirmInfo3">
              Autorizo minha Corretora Franqueada ser cadastrada no aplicativo
              oficial da PTC 2025. Este app será lançado posteriormente pela
              Franqueadora.
            </label>
          </div>
        </div>
        <button @click="$emit('goBack')">Voltar</button>
        <button :disabled="!confirmInfo1 || !confirmInfo2 || !confirmInfo3" @click="$emit('nextButton')">
          Próximo
        </button>
      </div>
      <div class="col-md-12" v-if="type === 3">
        <p>
          Agora que já preencheu suas informações, você deverá fazer o mesmo
          para os seus acompanhantes qualificados e/ou extras. Conforme o
          regulamento da Convenção de {{ currentYear }}, será permitido levar
          apenas 1 acompanhante extra.
        </p>
        <p>
          * Exceção à regra: quando o responsável técnico cadastrar somente
          <b>cônjuge e filhos</b> o número de acompanhantes extras poderá exceder esse
          limite.
        </p>
        <p>
          Número de acompanhantes permitidos conforme a qualificação da
          Franquia:<br /><br />

          Super Gold – 3 acompanhantes qualificados e 1 extra<br />
          Gold – 2 acompanhantes qualificados e 1 extra<br />
          Silver – 1 acompanhante qualificado e 1 extra<br />
          Bronze – 1 acompanhante extra<br />
          <br />
        </p>
        <p><b>Importante:</b></p>
        <p>
          <b>Sobre emissão de voos para bebês:</b>  As cias aéreas cobram uma taxa a ser calculada em cima da tarifa atual do adulto, 
          referente a crianças de até 01 ano e 11 meses (na ida e na volta). 
          À partir de 02 anos completos (inclusive se completados durante a viagem), será cobrado tarifa de criança.
        </p>

        <!-- <p>
          <strong>
            Importante: na 2ª fase não poderão ser cadastrados novos
            acompanhantes, portanto recomendamos cadastrar todos os seus
            possíveis acompanhantes nesse momento.
          </strong>
        </p> -->
        <button @click="$emit('goBack')">Voltar</button>
        <button @click="$emit('nextButton')">Próximo</button>
      </div>
      <div class="col-md-12" v-if="type === 4">
        <p>Responsáveis Técnicos e acompanhantes qualificados, se houver.</p>
        <hr />
        <p>
          Agora chegou o momento de escolher a sua opção de voo e de seus
          acompanhantes, se houver. Mas antes, seguem algumas informações
          importantes:
        </p>
        <p>
          .: A opção escolhida só está confirmada após a finalização da
          inscrição.<br />
          Confira a confirmação da sua inscrição que chegará em seu e-mail.
          <br />
          <br />
          .: Corretoras Franqueadas qualificadas na categoria Super Gold, 
          só poderão selecionar o grupo 0, pois terão seus voos de acordo com a sua preferência. 
          Vale ressaltar que caso o aéreo ultrapasse a tarifa base da Franqueadora, 
          esse custo adicional será de responsabilidade da empresa Franqueada.
            <br /><br />
          <!-- .: A opção de voo exclusiva da categoria Super Gold somente deve ser
          selecionada pelas Corretoras Franqueadas qualificadas nessa categoria,
          caso alguma Franquia não atenda esse critério e selecione essa opção a
          seleção será desconsiderada e os voos serão emitidos nas datas
          oficiais.<br /><br /> -->
          .: As datas oficiais <b>NÃO</b> tem limite de vagas e nem um voo
          definido, as emissões serão feitas conforme disponibilidade das cias
          aéreas.<br /><br />
          .: Na opção das datas oficiais não é permitido alterar os dias de ida
          e retorno.<br /><br />
          .: Com exceção das datas oficiais, as opções de voo possuem uma
          quantidade limitada de vagas, sendo assim caso durante seu acesso a
          opção não esteja disponível significa que as vagas já foram totalmente
          preenchidas.<br /><br />
          .: A escolha dos voos é somente para as Corretoras Franqueadas e
          acompanhantes qualificados. <b>Não estão contempladas as passagens aéreas
            dos acompanhantes extras</b>. Os voos desses participantes devem ser
          providenciados pelas Corretoras franqueadas.<br /><br />
          .:Os voos nas datas oficiais serão definidos pela Franqueadora conforme
          disponibilidade nas cias aéreas.<br /><br />
          .:⁠Caso seu acompanhante extra seja um menor de idade e opte por
          comprar o voo desse acompanhante por conta própria, por favor informe
          o aéreo para que a Origami possa atrelar ao seu bilhete emitido pela
          Franqueadora. Caso a compra do voo do acompanhante extra menor de
          idade seja feita com a Origami esse etapa de atrelar o bilhete é feita
          de forma automática.
          <br />
        </p>
        <!-- <p>
          <b>
            Somente serão emitidos os voos dos franqueados e acompanhantes
            qualificados que possuírem passaporte válido.
          </b>
        </p>
        <p>
          <b>Importante:</b> Os grupos possuem quantidades limitadas de vagas,
          então atentem-se na escolha de seus voos e dos seus acompanhantes para
          que não ocorram equívocos.
        </p> -->
        <p>Pronto(a)? Então, vamos lá!</p>
        <button @click="$emit('goBackRegister')">Voltar</button>
        <button @click="$emit('nextButton')">Próximo</button>
      </div>
      <!-- <div class="col-md-12" v-if="type === 4">
        <p>Atenção!</p>
        <hr />
            Lembramos que somente serão emitidos os voos dos franqueados
            qualificados que possuem passaporte e visto válidos.</b
          >
        </p>
        <p>
          <b>Importante:</b> após o envio da inscrição não poderão ser feitas
          alterações das informações preenchidas.
        </p>
        <p>Pronto(a)? Então, vamos lá!</p>
        <button @click="$emit('nextButton')">Próximo</button>
      </div> -->
      <!-- <div class="col-md-12" v-if="type === 4">
        <p>Atenção!</p>
        <hr />
        <p>
          Na próxima tela você realizará a seleção dos acompanhantes inscritos
          na primeira fase. Selecione suas indicações que automaticamente serão
          informados quais serão qualificados e quais serão extras de acordo com
          o regulamento da convenção de {{ currentYear }}.
        </p>
        <p style="color: red">
          Menores de 3 anos (2 anos e 11 meses) até a data do evento não possuem
          custos extras de participação na convenção, porém conforme a política
          das cias aéreas haverá custos nos voos.
        </p>
        <button @click="$emit('goBack', 'infoMessage1')">Voltar</button>
        <button @click="$emit('nextButton')">Próximo</button>
      </div> -->
      <div class="col-md-12" v-if="type === 5">
        <p>
          Agora que já foi feita a indicação dos acompanhantes, chegou o momento
          de escolher o voo.
        </p>
        <hr />
        <p>
          Mas antes, um pequeno lembrete: O acesso ao site é feito baseado na
          categoria de qualificação de sua franquia. Todas as opções de voos
          divulgadas no comunicado de aéreo têm um número limitado de vagas, com
          exceção das datas oficiais. Caso apareça menos opções significa que as
          vagas já foram preenchidas.
        </p>
        <p>Atente-se ao selecionar a opção adequada para cada participante.</p>
        <button @click="$emit('goBack')">Voltar</button>
        <button @click="$emit('nextButton')">Próximo</button>
      </div>
      <div class="col-md-12" v-if="type === 6">
        <p>
          Estamos quase finalizando, gostaríamos de saber se deseja realizar a
          reserva do transfer para seu acompanhante extra e se precisará de
          diárias extras no hotel da Convenção. O valor da diária do hotel
          consta no Comunicado de custos extras enviado pela Franqueadora.
          <br />
          A reserva de dias e/ou quartos adicionais para o hotel da PTC 2025
          estão sujeito a disponibilidade. Caso faça a solicitação aqui, a
          Franqueadora irá confirmar essa despesa adicional, posteriormente, no
          envio dos custos extras.
        </p>
        <p>
          Escolhendo a opção de adquirir o transfer será necessário informar a
          Origami Turismo qual será o voo de chegada e partida de seu
          acompanhante se este não foi emitido com a agência.
        </p>
        <p>
          Reforçamos que o valor do transfer também consta no Comunicado de
          custos extras.
        </p>

        <!-- <p>Canais de atendimento:</p>
        <p style="margin-bottom: 0px">
          Whatsapp: (21) 21 99981-5040 (SOMENTE MENSAGENS NÃO ATENDE LIGAÇÕES)
        </p>
        <p style="margin-bottom: 0px">E-mail: ptc2025@origamieventos.com.br</p>
        <p>Telefone: (21) 3798-9010</p> -->

        <p>
          <b>Importante:</b> Lembramos que o transfer oferecido pela
          Franqueadora para os responsáveis técnicos e acompanhantes
          qualificados é somente para chegadas e saídas nas datas oficiais da
          Convenção.
        </p>

        <button @click="$emit('goBack')">Voltar</button>
        <button @click="$emit('nextButton')">Próximo</button>
      </div>
      <!-- <div class="col-md-12" v-if="type === 7">
        <p>Falta só mais 1 etapa.</p>
        <p>
          O termo de autorização de imagem deve ser assinado por todos os
          acompanhantes, qualificados e extras. Após a assinatura envie o
          documento original para a área de Marketing Promocional ou digitalize
          e envie por e-mail para
          <a href="mailto:ptcpiic.brasil@prudential.com"
            >ptcpiic.brasil@prudential.com</a
          >
          .
        </p>
        <button @click="$emit('goBack')">Voltar</button>
        <button @click="$emit('nextButton')">Próximo</button>
      </div> -->
      <div class="col-md-12" v-if="type === 7">
        <p>
          Pronto! Agora é só conferir todas as informações e concluir a
          inscrição. Caso queira alterar alguma informação, basta clicar em
          voltar. Após o envio da inscrição, será enviado um e-mail com o resumo
          de todas as informações preenchidas no site.
        </p>
        <p>
          <strong>Importante:</strong> Somente após a finalização da sua
          inscrição a opção de voo selecionada está confirmada.
        </p>
        <button @click="$emit('goBack')">Voltar</button>
        <button @click="$emit('nextButton')">Finalizar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type"],
  data: () => {
    return {
      confirmInfo1: false,
      confirmInfo2: false,
      confirmInfo3: false,
      currentYear: "2025",
      startEvent: "20/04/2025",
      finalEvent: "24/04/2025",
      startTransfer: "20/04/2025",
      finalTransfer: "24/04/2025",
    };
  },
  mounted: () => {
    // let trasferDate = new Date();
    // trasferDate.setDate(store.state.finalEvent.getDate() + 1);
    // this.currentYear = store.state.startEvent.getFullYear();
    // this.startEvent = store.state.startEvent.toLocaleDateString();
    // this.finalEvent = store.state.finalEvent.toLocaleDateString();
    // this.finalTransfer = trasferDate.toLocaleDateString();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Infos.vue